 <a class='like-button' [ngClass]="{'liked':likeButtonLiked}" (click)="abrirFavoritos()">
      <span class='like-icon'>
        <div class='heart-animation-1'></div>
        <div class='heart-animation-2'></div>
      </span>
      {{nFavoritos}} {{ mostrarTexto ? 'Inmuebles' : ''}}
</a>
